"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mimeTypes = {
    svg: 'image/svg+xml',
    png: 'image/png',
    jpeg: 'image/jpeg'
};
function getMimeTypeFromDataUrl(url) {
    var f = getFormatFromDataUrl(url);
    return f && exports.mimeTypes[f];
}
exports.getMimeTypeFromDataUrl = getMimeTypeFromDataUrl;
function getFormatFromDataUrl(url) {
    return Object.keys(exports.mimeTypes).find(function (k) { return !!exports.mimeTypes[k] && url.includes(exports.mimeTypes[k]); });
}
exports.getFormatFromDataUrl = getFormatFromDataUrl;
//# sourceMappingURL=mimeTypes.js.map